(() => {
  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  function init(scope = document) {
    scope.querySelectorAll('media-gallery').forEach((gallery) => {
      if (gallery.dataset.beshoesVideoReady) return;

      const viewer = gallery.querySelector('[id^="GalleryViewer"]');
      if (!viewer) return;

      const players = [...viewer.querySelectorAll(
        '.media-type-video deferred-media'
      )];

      if (!players.length) return;
      gallery.dataset.beshoesVideoReady = 'true';

      let visiblePlayer = null;
      const visibility = new Map();

      // Configura os vídeos ainda dentro dos templates inativos.
      // Não cria leitores nem pede os ficheiros de vídeo nesta fase.
      players.forEach((player) => {
        const template = player.querySelector('template');
        const video = template?.content.querySelector('video');
        if (!video) return;

        video.removeAttribute('autoplay');
        video.autoplay = false;
        video.defaultMuted = true;
        video.muted = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('preload', 'none');
        video.setAttribute('loop', '');
        video.setAttribute('controls', '');
      });

      // Para vídeos nativos, a visibilidade controla o carregamento.
      // Fotografias, modelos 3D e vídeos externos mantêm a lógica do tema.
      const originalPlayActiveMedia = gallery.playActiveMedia;
      if (typeof originalPlayActiveMedia === 'function') {
        gallery.playActiveMedia = function (item) {
          if (item.querySelector('.media-type-video deferred-media')) {
            return;
          }
          return originalPlayActiveMedia.call(this, item);
        };
      }

      function pause(player) {
        const video = player.querySelector('video');
        if (video) video.pause();
      }

      function start(player) {
        if (
          reducedMotion.matches ||
          document.hidden ||
          !player.isConnected
        ) return;

        if (!player.querySelector('video')) {
          player.loadContent(false);
        }

        const video = player.querySelector('video');
        if (!video) return;

        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.loop = true;

        // Se o navegador bloquear autoplay, ficam os controlos nativos.
        const attempt = video.play();
        if (attempt?.catch) attempt.catch(() => {});
      }

      function update() {
        let next = null;
        let bestRatio = 0;

        visibility.forEach((ratio, player) => {
          if (ratio >= 0.6 && ratio > bestRatio) {
            next = player;
            bestRatio = ratio;
          }
        });

        if (document.hidden || reducedMotion.matches) next = null;
        if (next === visiblePlayer) return;

        players.forEach((player) => {
          if (player !== next) pause(player);
        });

        visiblePlayer = next;
        if (next) start(next);
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          visibility.set(
            entry.target,
            entry.isIntersecting ? entry.intersectionRatio : 0
          );
        });
        update();
      }, {
        threshold: [0, 0.6, 0.8, 1],
      });

      players.forEach((player) => {
        observer.observe(player);

        // Permite reprodução por clique, incluindo movimento reduzido.
        const poster = player.querySelector('.deferred-media__poster');
        poster?.addEventListener('click', () => {
          const video = player.querySelector('video');
          if (!video) return;

          video.muted = true;
          video.playsInline = true;
          const attempt = video.play();
          if (attempt?.catch) attempt.catch(() => {});
        });
      });

      document.addEventListener('visibilitychange', update);
      reducedMotion.addEventListener('change', () => {
        visiblePlayer = null;
        players.forEach(pause);
        update();
      });

      // Liberta os observadores quando a secção é removida no editor.
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(gallery)) return;
        observer.disconnect();
        players.forEach(pause);
        document.removeEventListener('visibilitychange', update);
      }, { once: true });
    });
  }

  async function boot(scope) {
    await customElements.whenDefined('media-gallery');
    await customElements.whenDefined('deferred-media');
    init(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document), {
      once: true,
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });
})();
